import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ReportProblemIcon from '@mui/icons-material/ReportProblem';
import { Box, Snackbar, Stack, Typography } from '@mui/material';
import { useEffect, useState } from 'react';

import { jhTheme } from '../../../themeProvider';

export interface MessageToastProps {
  showMessage: boolean | undefined;
  message: string;
  errorType: 'error' | 'success' | 'information';
}

const getStyle = (
  errorType: any,
): {
  bgcolor: string;
  padding: number;
  width: string;
  color: string;
} => {
  let bgColor;
  let fontColor = 'white';
  if (errorType === 'success') {
    bgColor = jhTheme.palette.success.main;
  } else if (errorType === 'error') {
    bgColor = jhTheme.palette.error.dark;
  } else {
    bgColor = jhTheme.palette.primary.main;
    fontColor = 'black';
  }
  return {
    bgcolor: bgColor,
    padding: 1,
    color: fontColor,
    width: '500px',
  };
};

export const CustomMessageToast = (props: MessageToastProps) => {
  const { errorType, message, showMessage } = props;

  const [showToast, setShowToast] = useState(false);

  const handleClose = () => {
    setShowToast(false);
  };

  useEffect(() => {
    if (showMessage) {
      setShowToast(true);
    }
  }, [showMessage]);

  return (
    <Snackbar
      open={showToast}
      autoHideDuration={6000}
      onClose={handleClose}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
    >
      <Box sx={getStyle(errorType)}>
        <Stack
          direction="row"
          spacing={3}
          alignItems="center"
          justifyContent="flex-start"
        >
          {errorType === 'success' ? (
            <CheckCircleIcon fontSize="large" />
          ) : (
            <ReportProblemIcon fontSize="large" />
          )}
          <Typography variant="button">{message}</Typography>
        </Stack>
      </Box>
    </Snackbar>
  );
};
